const API_KEY = '7a85d1405e6088e9629da10b22f2c4d2';
export default API_KEY
